import { gql } from '__generated__';

export default gql(`
  mutation DeactivateParticipant($input: DeactivateParticipantInput!) {
    deactivateParticipant(input: $input) {
      id
      active
      deactivated_at
    }
  }
`);
